import styled from 'styled-components'

import { E_Colors } from '@/helpers/colors'


export const SC_OrganizationsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
`

export const SC_Organization = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  cursor: pointer;

  img {
    width: 40px;
    border-radius: 50%;
  }

  > :last-child {
    display: flex;
    flex-direction: column;

    > :first-child {
      font-size: 17px;
    }

    > :last-child {
      font-size: 11px;
      color: ${E_Colors.GrayA3}
    }
  }
`
